module.exports = __webpack_public_path__ + "img/register.5ac83e97.svg";